// extracted by mini-css-extract-plugin
module.exports = {"ImagesList":"ImagesList_ImagesList__k6rS9"};